import { FormControlLabel } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

/**
 * The SCSS this replaced referenced CSS custom properties (`--neutrals-solid-100`,
 * `--green-25`, …) that are declared nowhere in the app, so only their literal
 * fallbacks ever rendered — and those fallbacks were pre-Figma-palette values.
 * Reading the same roles through the theme picks up the migrated palette.
 */

export const StatementsWrapper = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  borderRadius: '0.75rem',
  padding: '1rem',
}));

export const StatementList = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  borderRadius: '0.5rem',
  padding: '1rem',
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  overflowY: 'auto',
}));

export const Statement = styled(FormControlLabel)({
  display: 'flex',
  gap: '1rem',
  alignItems: 'flex-start',
});

export const StatementText = styled('span')(({ theme }) => ({
  color: alpha(theme.palette.grey[0], 0.95),
  fontSize: '0.875rem',
  lineHeight: 1.6,
  fontWeight: 500,
}));

/**
 * The custom round checkbox. `checked` drives the fill and the checkmark stroke;
 * it is stripped before the DOM because `checked` on a `<span>` is not valid HTML.
 */
export const CheckboxIconRoot = styled('span', {
  shouldForwardProp: (prop) => prop !== 'checked',
})<{ checked?: boolean }>(({ theme, checked }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '1.5rem',
  height: '1.5rem',
  borderRadius: '50%',
  border: `1px solid ${checked ? 'transparent' : alpha(theme.palette.grey[0], 0.3)}`,
  backgroundColor: checked ? alpha(theme.palette.custom.green.ish700, 0.5) : 'transparent',
  transition: theme.transitions.create(['background-color', 'border-color'], {
    duration: theme.transitions.duration.shorter,
  }),
  '& svg': {
    width: '0.75rem',
    height: '0.5rem',
  },
  '& svg path': {
    // Checked used `--green-150`; the darkest green the theme exposes is custom.green[800].
    stroke: checked ? theme.palette.custom.green[800] : alpha(theme.palette.grey[0], 0.3),
    transition: theme.transitions.create('stroke', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));
